import { getListings } from '../getListings';
import { getActiveProduct } from '../selectors';

export const LISTING_REFRESH_SOCKET_EVENTS = [
  'products.listingRefresh.complete',
  'products.listingRefresh.failed',
];

export const shouldRefetchListingsOnRefreshEvent = ({
  masterProductId,
  openMasterProductId,
  isLiveRefreshing,
}) => {
  if (!masterProductId || !openMasterProductId) return false;
  if (String(openMasterProductId) !== String(masterProductId)) return false;
  return Boolean(isLiveRefreshing);
};

export const handleListingRefreshSocketEvent = (event, {
  dispatch,
  getState,
  getLocation = () => ({ pathname: window.location.pathname }),
}) => {
  const masterProductId = event?.data?.masterProductId;
  const openProduct = getActiveProduct(getLocation());
  const isLiveRefreshing = Boolean(
    getState()?.products?.ui?.liveRefreshingByProductId?.[masterProductId],
  );

  if (!shouldRefetchListingsOnRefreshEvent({
    masterProductId,
    openMasterProductId: openProduct?.productId,
    isLiveRefreshing,
  })) {
    return;
  }

  dispatch(getListings({
    masterProductId,
    masterVariantId: openProduct?.variantId || null,
    skipLiveRefreshPoll: true,
  }));
};
